import Radios from "PFComponents/radios/radios";
import React from "react";
import { useTranslation } from "react-i18next";

export enum ReassignSelectOption {
  ThisBooking = "ThisBooking",
  AllBookings = "AllBookings"
}

type BookingsToReassignSelectorProps = {
  roleBookingsIds: number[];
  reassignOptionSelected: string;
  setReassignOptionSelected: React.Dispatch<React.SetStateAction<string>>;
};

export const BookingsToReassignSelector = ({
  roleBookingsIds,
  reassignOptionSelected,
  setReassignOptionSelected
}: BookingsToReassignSelectorProps): JSX.Element => {
  const { t } = useTranslation("bookingModule");
  return (
    <div>
      <Radios<ReassignSelectOption>
        items={[
          { id: ReassignSelectOption.ThisBooking, text: t("bookings.reassign.reassignThisBooking") },
          {
            id: ReassignSelectOption.AllBookings,
            text: t("bookings.reassign.reassignAllBookings", { count: roleBookingsIds.length })
          }
        ]}
        value={reassignOptionSelected}
        handleChange={(item) => setReassignOptionSelected(item.id)}
      />
    </div>
  );
};
